import { SnailyError } from './SnailyError'

export class EmptySearchPageError extends SnailyError {
	declare url: string | undefined

	constructor(
		response: string | { statusText?: string; url?: string },
		metadata?: unknown
	) {
		const message =
			typeof response === 'string' ? response : (response?.statusText ?? '')
		super(message, metadata)
		this.name = 'EmptySearchPageError'
		this.url = typeof response === 'object' && response != null ? response.url : undefined

		if (typeof Error.captureStackTrace === 'function') {
			Error.captureStackTrace(this, EmptySearchPageError)
		}
	}
}
